<template>
  <div class="footlist"> 
    <div class="left">
      <img src="../assets/footer/footer.png"
          srcset="../assets/footer/footer@2x.png 2x,
                  ../assets/footer/footer@3x.png 3x"
          class="footerimg">
    </div>
    <div class="middle">
      <!-- <img src="../assets/fb/fb.png"
            srcset="../assets/fb/fb@2x.png 2x,
                   ../assets/fb/fb@3x.png 3x"
            class="icon">
      <img src="../assets/mail/mail.png"
          srcset="../assets/mail/mail@2x.png 2x,
                  ../assets/mail/mail@3x.png 3x"
          class="icon"> -->
    </div>
    <div class="right">
      <a href="https://www.facebook.com/kingstonecy1986/">
      <img src="../assets/fb/fb.png"
            srcset="../assets/fb/fb@2x.png 2x,
                   ../assets/fb/fb@3x.png 3x"
            class="icon">
      </a>
      <a href="mailto:cs@kingstonecy.com.tw" target="_blank">      
      <img src="../assets/mail/mail.png"
          srcset="../assets/mail/mail@2x.png 2x,
                  ../assets/mail/mail@3x.png 3x"
          class="icon"></a>
      <img src="../assets/logobanner/k.png"
          srcset="../assets/logobanner/k@2x.png 2x,
                  ../assets/logobanner/k@3x.png 3x"
          class="logobanner_k">
      <p class="text_k">2013©®金石建設股份有限公司™ King-Stone Development LLC</p>
    </div>
  </div>
</template>

<script>
  export default {
  name: 'footlist',
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footlist{
  width: 100vw;
  height: 97px;
  display:block;
  padding: 5% 0 4% 0;
  position: relative;
  background-image: linear-gradient(76deg, #dadad9 10%, #ebebeb 33%, #feffff);
  /* background:black; */
}
.left, .middle, .right{
  display: inline-block;
  vertical-align: top;
}
.left{
  margin: 0 8%;
}
.footerimg{
  width: 100%;
}

.middle{
  margin: 0 8%;
}

.icon {
  position:relative;
  height: 28px;
  margin: 0 18px 0 0;
  object-fit: contain;
  background: transparent;
}
.icon:hover{
  cursor: pointer;
}

.right{
  margin: 0 0 0 6%;
}
.logobanner_k{
  margin: 0 0 0 25%;
  position:relative;
  width: auto;
  height: 37px;
  object-fit: contain;
}
.text_k {
  text-align:right;
  vertical-align:bottom;
  margin-top: 7.5%;
  width: 429px;
  height: 17px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.79px;
  color: #8a8a8a;
}
</style>
